let column = 3;
let id = 2000000;
import Col from '../base/one_column';
import Row from '../base/one_row';
import Module from '../base/one_module';
import IMG0 from '@/assets/0.jpg';
import IMG1 from '@/assets/1.jpg';
import IMG2 from '@/assets/2.jpg';
import IMG3 from '@/assets/3.jpg';
import IMG6 from '@/assets/6.jpg';

export function create_data(rowType) {
  let list = []
  for(let i = 0;i<4;i++){
    id++;
    const row_id = id;
    const row = new Row({
      widgets_id:id,
      rowType
    });
    for(let j = 0;j<column;j++){
      id++;
      const col = new Col({
        widgets_id:id,
        rowType,
        pid:row_id
      });
      col.data.pc_infor.col = 4;
      col.data.mb_infor.col = 2;

      for(let i = 0;i<8;i++){
        id++;
        const module = new Module({
          widgets_id:id,
          rowType,
          pid:row_id,
          name:'basic_picture'
        });
        const num = Math.random();
        if(num<0.2){
          module.data.listArr.url = IMG0;
        }
        else if(num>=0.2 && num<0.4){
          module.data.listArr.url = IMG1;
        }
        else if(num>=0.4 && num<0.6){
          module.data.listArr.url = IMG2;
        }
        else if(num>=0.6 && num<0.8){
          module.data.listArr.url = IMG3;
        }
        else{
          module.data.listArr.url = IMG6;
        }
        module.data.pc_infor.marginLeft = '20%';
        module.data.pc_infor.marginRight = '20%';
        module.data.pc_infor.marginTop = '5%';

        if(Math.random() > 0.75){
          col.children.push(module);
        }

      }

      row.children.push(col);
    }
    list.push(row);
  }
  return list;
}
export function create_header(rowType) {
  let list = []
  const row_id = id;
  id++;
  const rowHeader = new Row({
    widgets_id:id,
    rowType,
    is_system:'true'
  });
  rowHeader.data.is_system = 'true';
  for (let i = 0; i < column; i++) {
    id++;
    const colHeader = new Col({
      widgets_id:id,
      rowType,
      pid:row_id
    });
    colHeader.data.pc_infor.col = 6;
    id++;
    const moduleTitle = new Module({
      widgets_id:id,
      rowType,
      pid:row_id,
      name:'basic_webtitle'
    });
    moduleTitle.data.is_system = 'true';
    id++;
    const moduleNav = new Module({
      widgets_id:id,
      rowType,
      pid:row_id,
      name:'basic_navbar'
    });
    moduleNav.data.is_system = 'true';
    if(i==0){
      colHeader.children.push(moduleTitle)
    }else if(i==1){
      colHeader.children.push(moduleNav)
    }
    rowHeader.children.push(colHeader)
  }
  let tag = false
  for (let j = 0; j < list.length; j++) {
    if(list[j].is_system&&list[j].is_system=='true'){
      tag  = true
    }
  }
  if(!tag){
    list.push(rowHeader)
  }
  return list;
}



// WEBPACK FOOTER //
// ./src/test/data.js